export class UsersPickerModalController implements ng.IController {
  networkError: boolean;
  usersIds: Set<string>;
  isMultiple: boolean;
  isUsersSelectionValid: boolean;
  isUsersIdsTooLarge: boolean;

  // bindings
  max: number;
  selectedUsers: string[];
  onClose: () => void;
  onSave: ({}: { usersIds: string[] }) => void;

  constructor() {
    'ngInject';
  }

  $onInit(): void {
    this.networkError = false;
    this.usersIds = new Set(this.selectedUsers);
    this.isMultiple = this.max > 1;
    this.onUsersChanges();
  }

  onUserSelect(userId: string): void {
    if (!this.isMultiple) {
      this.usersIds.clear();
    }
    this.usersIds.add(userId);

    this.onUsersChanges();
  }

  onUserUnselect(userId: string): void {
    this.usersIds.delete(userId);

    this.onUsersChanges();
  }

  onUserListLoadingSuccess(): void {
    this.networkError = false;
  }

  onUserListLoadingError(): void {
    this.networkError = true;
  }

  confirmSelection(): void {
    this.onSave({ usersIds: Array.from(this.usersIds) });
    this.onClose();
  }

  isUsersIdsEmpty(): boolean {
    return this.usersIds.size === 0;
  }

  checkIfUsersIdsTooLarge(): boolean {
    return this.usersIds.size > this.max;
  }

  checkIfUsersSelectionValid(): boolean {
    return !this.isUsersIdsEmpty() && !this.checkIfUsersIdsTooLarge();
  }

  onUsersChanges(): void {
    this.isUsersIdsTooLarge = this.checkIfUsersIdsTooLarge();
    this.isUsersSelectionValid = this.checkIfUsersSelectionValid();
  }
}
